import { render, staticRenderFns } from "./students_sidebar.vue?vue&type=template&id=52d32322&scoped=true&"
import script from "./students_sidebar.vue?vue&type=script&lang=js&"
export * from "./students_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./students_sidebar.vue?vue&type=style&index=0&id=52d32322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d32322",
  null
  
)

export default component.exports